import { render, staticRenderFns } from "./ProductOrderForm.vue?vue&type=template&id=22867de0&scoped=true"
import script from "./ProductOrderForm.vue?vue&type=script&lang=ts"
export * from "./ProductOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductOrderForm.vue?vue&type=style&index=0&id=22867de0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22867de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22867de0')) {
      api.createRecord('22867de0', component.options)
    } else {
      api.reload('22867de0', component.options)
    }
    module.hot.accept("./ProductOrderForm.vue?vue&type=template&id=22867de0&scoped=true", function () {
      api.rerender('22867de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consignment/components/ProductOrderForm.vue"
export default component.exports